export default __webpack_public_path__ + "static/media/auto-configuration.160e7484.svg";